interface PlanHeaderProps {
  totalCount: number;
  search: string;
  onSearchChange: (v: string) => void;
  onAdd: () => void;
  onRefresh: () => void;
}

export default function PlanHeader({
  totalCount,
  search,
  onSearchChange,
  onAdd,
  onRefresh,
}: PlanHeaderProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
      <h2 className="font-serif text-brand-black text-2xl font-medium">
        Planes Asesoría{" "}
        <span className="text-brand-gray-400">({totalCount})</span>
      </h2>
      <div className="flex items-center gap-3">
        <input
          type="text"
          placeholder="Buscar plan..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          className="w-full sm:w-64 bg-white border border-brand-gray-200 rounded-lg px-4 py-2.5 font-sans text-sm focus:outline-none focus:border-brand-black"
        />
        <button
          onClick={onAdd}
          className="bg-brand-black text-white font-sans text-sm px-5 py-2.5 rounded-lg hover:bg-brand-gray-600 transition-colors whitespace-nowrap"
        >
          + Nuevo plan
        </button>
        <button
          onClick={onRefresh}
          className="w-10 h-10 rounded-lg bg-white border border-brand-gray-200 flex items-center justify-center text-brand-gray-600 hover:text-brand-black hover:border-brand-black transition-colors"
          title="Recargar"
        >
          <i className="ri-refresh-line" />
        </button>
      </div>
    </div>
  );
}